type Language = 'ko' | 'en' | 'ja';

import { PaymentMethod } from './index_types.2';

export const PAYMENT_METHOD_LABEL: Record<
  keyof typeof PaymentMethod | 'KAKAOPAY_MONEY' | 'TOSSPAY_MONEY',
  Record<Language, string>
> = {
  CARD: { ko: '신용/체크카드', en: 'Credit/Check card', ja: '韓国クレジットカード' },
  BANK: { ko: '계좌이체', en: '계좌이체', ja: '계좌이체' }, // 현재 지원하지 않음
  VBANK: { ko: '무통장', en: 'Virtual Accounts', ja: '仮想口座決済' },
  PHONE: { ko: '휴대폰', en: 'Phone bill', ja: 'キャリア決済' },
  SIMPLE_CARD: { ko: '카드 간편결제', en: '카드 간편결제', ja: '카드 간편결제' }, // 현재 지원하지 않음
  SIMPLE_BANK: { ko: '계좌 간편결제', en: 'Simple payment(bank)', ja: '口座かんたん決済' },
  BENEPIA_POINT: { ko: '베네피아 포인트', en: '베네피아 포인트', ja: '베네피아 포인트' }, // 현재 지원하지 않음
  KAKAOPAY: { ko: '카카오페이', en: 'KakaoPay', ja: 'カカオペイ' },
  KAKAOPAY_MONEY: { ko: '카카오페이머니', en: 'KakaoPay Money', ja: 'KakaoPay Money' },
  TOSSPAY: { ko: '토스페이', en: 'TossPay', ja: 'TossPay' },
  TOSSPAY_MONEY: { ko: '토스페이계좌', en: 'TossPay Money', ja: 'TossPay Money' },
  GLOBAL_CARD: {
    ko: '신용카드(해외에서 발급)',
    en: 'Credit card (Issued outside of Korea)',
    ja: 'クレジットカード（海外発行）',
  },
  CONVENIENCE_STORE: { ko: '편의점 결제', en: 'Convenience store', ja: 'コンビニ決済' },
  CONVENIENCE_STORE_JP: { ko: '편의점 결제', en: 'Convenience store', ja: 'コンビニ決済' },
  POINT: { ko: '포인트', en: 'Point', ja: 'ポイント' },
  UNDEFINED_PAYMENT_METHOD: { ko: '알 수 없는 결제수단', en: 'Unknown payment method', ja: '不明な決済手段' },
};

// 국제배송의 경우 신용카드 레이블이 다름
export const GLOBAL_PAYMENT_METHOD_LABEL: Record<keyof typeof PaymentMethod, Record<Language, string>> = {
  ...PAYMENT_METHOD_LABEL,
  CARD: { ko: '신용카드(한국에서 발급)', en: 'Credit card (Issued in Korea)', ja: 'クレジットカード（韓国発行）' },
  GLOBAL_CARD: { ko: '신용카드', en: 'Credit/debit card', ja: 'クレジットカード' },
};

export const CARD_LABEL: Record<'신용카드' | '체크카드', Record<Language, string>> = {
  신용카드: { ko: '신용카드', en: 'Credit Card', ja: 'クレジットカード' },
  체크카드: { ko: '체크카드', en: 'Debit Card', ja: 'デビットカード' },
};

/**
 * 결제수단 코드로 결제수단 이름을 반환한다.
 * @param lang 언어
 * @param payment_method 결제수단 코드
 */
export const getPaymentMethodLabel = (lang: Language, payment_method: keyof typeof PaymentMethod): string => {
  if (!PAYMENT_METHOD_LABEL[payment_method]) {
    return '-';
  }
  return PAYMENT_METHOD_LABEL[payment_method][lang];
};

export const getCardTypeLabel = (lang: Language, card_type: '신용카드' | '체크카드'): string => {
  if (!CARD_LABEL[card_type]) {
    return '-';
  }
  return CARD_LABEL[card_type][lang];
};
